import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Avatar,
  CircularProgress,
} from "@mui/material";
import useSharedLocation from "../hooks/useSharedLocation";
import { WEATHER_API_KEY } from "../globals/const";

const WeatherWidget = () => {
  const [weatherData, setWeatherData] = useState(null);
  const apiKey = WEATHER_API_KEY;

  const { location } = useSharedLocation();

  useEffect(() => {
    const fetchData = async () => {
      if (!location) return;

      try {
        const response = await fetch(
          `https://api.weatherapi.com/v1/forecast.json?key=${apiKey}&q=${location.latitude},${location.longitude}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch weather data");
        }
        const data = await response.json();
        setWeatherData(data);
      } catch (error) {
        console.error("Error fetching weather data:", error);
      }
    };

    fetchData();
  }, [location]);

  return (
    <Card
      variant="outlined"
      sx={{ p: 1 }}
      style={{ height: "80px", background: "#5397E2" }}
    >
      <CardContent>
        {weatherData ? (
          <Grid container>
            <Grid item xs={3}>
              <Typography style={{ color: "white", fontSize: "2rem" }}>
                {weatherData.current.temp_c ? weatherData.current.temp_c : ""}
                °C
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: "white",
                  textAlign: "center",
                  padding: "0 0 0 5px",
                }}
                my={1}
              >
                {location.district}, {weatherData.location.country}
              </Typography>
            </Grid>
            <Box
              item
              xs={3}
              sx={{
                py: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center", // Horizontally center the content
              }}
            >
              <Avatar
                src={weatherData.current.condition.icon}
                alt={weatherData.current.condition.text}
                sx={{ width: 60, height: 60 }} // Adjust the width and height as needed
              />
            </Box>
          </Grid>
        ) : (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <CircularProgress color="inherit" />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
export default WeatherWidget;
